import React, {useState} from 'react';
import {Modal, Button, Icon, Table} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {useDispatch, useSelector} from 'react-redux';

const {
  fecthComboAccessoriesList,
  cleanComboAccessoriesList,
} = Actions;

const ComboAccessoriesModal = ({code}) => {
  const [modalOpened, setModalOpened] = useState(false);
  const comboAccessoriesList = useSelector((state) => state.comboAccessories.list);
  const dispatch = useDispatch();

  const openComboAccessoriesModal = (e) => {
    e.preventDefault();
    dispatch(fecthComboAccessoriesList(code));
    setModalOpened(true);
  };

  const closeComboAccesorioesModal = (e) => {
    e.preventDefault();
    dispatch(cleanComboAccessoriesList());
    setModalOpened(false);
  };

  return (
    <Modal
      trigger={<Icon className='toolbox' size='big' color={'red'} link
        onClick={(e) => openComboAccessoriesModal(e)} />
      }
      open={modalOpened}
      onClose={(e) => openComboAccessoriesModal(e)}
      size='large'
    >
      <Modal.Header>Accesorios incluidos</Modal.Header>
      <Modal.Content>
        <div className="m-2">
          <Table striped className='dashboard-table'>
            <Table.Header className='orders-table-header'>
              <Table.Row>
                <Table.HeaderCell>Código</Table.HeaderCell>
                <Table.HeaderCell>Franquicia</Table.HeaderCell>
                <Table.HeaderCell>Descripción</Table.HeaderCell>
                <Table.HeaderCell>Cantidad</Table.HeaderCell>
                <Table.HeaderCell>Precio</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {comboAccessoriesList ?
                comboAccessoriesList.map((item, index) => {
                  return <Table.Row key={index}>
                    <Table.Cell>{item.code}</Table.Cell>
                    <Table.Cell>{item.franchise}</Table.Cell>
                    <Table.Cell>{item.name}</Table.Cell>
                    <Table.Cell>{item.quantity}</Table.Cell>
                    <Table.Cell>{item.price}</Table.Cell>
                  </Table.Row>;
                }) : ''
              }
            </Table.Body>
          </Table>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button color='black' onClick={(e) => closeComboAccesorioesModal(e)}>
              Cerrar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ComboAccessoriesModal;
